import { JSObject } from "../types/Common";
import { ApiClient } from "../apiClient";
require('dotenv').config();

const baseURL = process.env.REACT_APP_API_URL !== undefined ? process.env.REACT_APP_API_URL : '';
const apiClient = new ApiClient(baseURL);

export class AnswerDeliveryApi {
    static update(params: JSObject): Promise<unknown> {
        return apiClient.post('/api/answerDelivery', params);
    }
}